import { z } from "zod";

export const NOTE_BODY_MAX = 1000;

export const noteSchema = z.object({
	severity: z.enum(["info", "warning", "critical"]),
	stageId: z.string(),
	body: z
		.string()
		.trim()
		.min(1, "Escreva a observação.")
		.max(
			NOTE_BODY_MAX,
			`A observação deve ter no máximo ${NOTE_BODY_MAX} caracteres.`,
		),
});

export type NoteFormValues = z.infer<typeof noteSchema>;
